import useSigV4Client from "@aws-northstar/ui/components/CognitoAuth/hooks/useSigv4Client";
import { useContext, useMemo } from "react";
import {
  DefaultApi as VenueLoyaltyAPIApi,
  Configuration as VenueLoyaltyAPIApiConfiguration,
} from "venue-loyalty-api-typescript-react-query-hooks";
import { RuntimeConfigContext } from "../components/RuntimeContext";

export const useVenueLoyaltyAPIApiClient = () => {
  const client = useSigV4Client();
  const runtimeContext = useContext(RuntimeConfigContext);

  return useMemo(() => {
    return runtimeContext?.typeSafeApis?.VenueLoyaltyAPI
      ? new VenueLoyaltyAPIApi(
          new VenueLoyaltyAPIApiConfiguration({
            basePath: runtimeContext.typeSafeApis.VenueLoyaltyAPI,
            fetchApi: client,
          }),
        )
      : undefined;
  }, [client, runtimeContext?.typeSafeApis?.VenueLoyaltyAPI]);
};
